<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1667 9.15383V10.7564M0.5 9.15383L0.5 10.7564M8.91346 5.54807V4.34614M8.91346 4.34614C8.91346 3.70512 9.47436 3.14422 10.1154 3.14422H14.1218C14.7628 3.14422 15.3237 3.70512 15.3237 4.34614V5.54807V1.70192C15.3237 1.0609 14.7628 0.5 14.1218 0.5L3.54487 0.5C2.90385 0.5 2.34295 1.0609 2.34295 1.70192V5.54807V4.34614C2.34295 3.70512 2.90385 3.14422 3.54487 3.14422H7.71154C8.35256 3.14422 8.91346 3.70512 8.91346 4.34614ZM17.1667 9.55448H0.5V7.15063C0.5 6.26922 1.22115 5.54807 2.10256 5.54807H15.5641C16.4455 5.54807 17.1667 6.26922 17.1667 7.15063V9.55448Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
